import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgRefresh = (props: SvgProps) => (
  <Svg fill="none" height={25} width={25} {...props}>
    <Path
      clipRule="evenodd"
      d="M15.072 5.89A7.21 7.21 0 0 0 7.28 7.227a1 1 0 0 1-1.363-1.463 9.211 9.211 0 0 1 15.489 6.74 1 1 0 1 1-2 0 7.21 7.21 0 0 0-4.334-6.612M9.013 18.968a7.21 7.21 0 0 0 7.585-.76 1 1 0 1 1 1.221 1.584 9.21 9.21 0 0 1-14.835-7.295 1 1 0 1 1 2 0 7.21 7.21 0 0 0 4.03 6.471"
      fill={props.color}
      fillRule="evenodd"
    />
    <Path
      clipRule="evenodd"
      d="M.585 14.476a1 1 0 0 1 0-1.414l2.877-2.876a1 1 0 0 1 1.414 0l2.876 2.876a1 1 0 1 1-1.414 1.414l-2.17-2.17L2 14.477a1 1 0 0 1-1.414 0M23.997 11.237a1 1 0 0 1 0 1.414l-2.876 2.877a1 1 0 0 1-1.415 0L16.83 12.65a1 1 0 1 1 1.414-1.414l2.17 2.17 2.17-2.17a1 1 0 0 1 1.413 0"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgRefresh);
export default Memo;
